const config = {
  environment: "local",
  // Quality values

  TITLE: "B2BPortal [LOC]",
  PRE_VERSION: "LOC",
  VIEWPORT: 1100,
  YODA_BACKEND: "https://api-it.seryon.io",
  TENANT_ID: "54f19899-cddf-46c2-94f5-b452053d3e5b",
  ORDER_TYPE_REORDER: 1,
  ORDER_TYPE_SWAP: 2,
  CONCURRENT_ORDER_API: true,
  PAGE_SIZE: 30,
  FVL: false,
  CODE_VERSION: "7.9.49-h",
  CLIENTID: "81b71513-c477-4bdd-974e-9a94a501e089",
  AUTHORITY:
    "https://hernob2b.b2clogin.com/HernoB2B.onmicrosoft.com/B2C_1_SignIn",
  AUTHORITYDOMAIN: "hernob2b.b2clogin.com",
  // override with sourced config
  ...process.env,
  ...window.env,
};

console.log(
  `%c ___ ___       __    __ __
|   Y   .---.-|  |--|__|  |_
|.  1   |  _  |  _  |  |   _|
|.  _   |___._|_____|__|____|
|:  |   |.°habit v.1.3.5 o°.
|::.|:. |'o conn3c|-ed to ` +
    config.environment +
    ` [\\]° \`
\`--- ---'`,
  "font-family:monospace",
);
export default config;
